import cn from 'classnames'
import React from 'react'

import themeVars from 'ui_theme/site/globals/site.variables'
import { WithGlobalNav } from 'components/App/DesktopView/Layout/GlobalNav'
import Title from 'components/App/Title'
import Tracking from 'components/App/Tracking'
import { BusinessHoursNotice, ControlBar } from 'ducks/reports/controls'
import { Grid } from 'util/ui'
import SUI from 'shared/components/ui/SUI'

import ReportsSidebar from '../ReportsSidebar'
import styles from './styles.less'

export default class ReportsLayout extends React.Component {
  componentDidMount() {
    if (!this.props.layoutMounted) this.props.onComponentDidMount()
  }

  componentDidUpdate() {
    if (!this.props.layoutMounted) this.props.onComponentDidUpdate()
  }

  render() {
    const { children, layoutMounted } = this.props
    return (
      <SUI transparent={false}>
        <Title />
        <Tracking />
        <WithGlobalNav
          active="Reporting"
          leftSidebar={<ReportsSidebar />}
          leftSidebarBg={themeVars.space}
        >
          <div className={styles.app}>
            <div className={cn('AppMain', 'ReportsApp', styles.content)}>
              <ControlBar prerenderDatePicker={layoutMounted} />
              {layoutMounted && (
                <div className={styles.scrollContainer}>
                  <div className={styles.widthContainer}>
                    <Grid columns={1} stackable padded>
                      <Grid.Column width={16}>
                        <BusinessHoursNotice />
                        <React.Fragment>{children}</React.Fragment>
                      </Grid.Column>
                    </Grid>
                  </div>
                </div>
              )}
            </div>
          </div>
        </WithGlobalNav>
      </SUI>
    )
  }
}
